import { memo } from "react";
import PerformantCarousel from "./PerformantCarousel";
import { carGalleries } from "@/data/galleryData";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";

interface LightweightGalleryGridProps {
  activeFilter: string;
}

const LightweightGalleryGrid = memo(({ activeFilter }: LightweightGalleryGridProps) => {
  const { elementRef, isIntersecting } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: '100px'
  });

  if (activeFilter === "all") {
    const displayOrder = ['bmw-seria-1', 'kia-sportage', 'skoda-rapid', 'opel-mokka', 'ford-transit'];
    const galleriesToRender = displayOrder
      .map(key => carGalleries[key] ? ({ key, ...carGalleries[key] }) : null)
      .filter((g): g is NonNullable<typeof g> => g !== null);

    return (
      <div ref={elementRef as any} className="grid md:grid-cols-2 xl:grid-cols-3 gap-8 mb-20 fade-in-fast">
        {isIntersecting && galleriesToRender.map((gallery, index) => (
          <PerformantCarousel 
            key={gallery.key}
            images={gallery.images}
            title={gallery.title}
            packageDescription={gallery.packageDescription}
            carType={gallery.key}
          />
        ))}
      </div>
    );
  }

  const selectedGallery = carGalleries[activeFilter];
  
  if (selectedGallery) {
    return (
      <div className="max-w-2xl mx-auto mb-20 fade-in-fast">
        <PerformantCarousel 
          images={selectedGallery.images}
          title={selectedGallery.title}
          packageDescription={selectedGallery.packageDescription}
          carType={activeFilter}
        />
      </div>
    );
  }

  return null;
});

LightweightGalleryGrid.displayName = 'LightweightGalleryGrid';

export default LightweightGalleryGrid;